import { render } from "./Cascader.vue?vue&type=template&id=52329a28"
import script from "./Cascader.vue?vue&type=script&lang=ts"
export * from "./Cascader.vue?vue&type=script&lang=ts"
script.render = render

export default script